'use strict'

// A sample component

const News = {
    init: function () {
        if (document.querySelector('.js-load-more')) {
            this.loadMore();

        }
    },
    loadMore: function () {
        const listContainer = document.querySelector('.block-list__wrapper');
        const btnLoadMore = document.querySelector('.js-load-more');
        const lang = btnLoadMore.getAttribute('data-lang');
        let offset = btnLoadMore.getAttribute('data-offset');
        btnLoadMore.addEventListener('click', () => {

            var formdata = new FormData();

            var requestOptions = {
                method: 'POST',
                body: formdata
            };

            fetch(`${api.news}${lang}/${offset}/`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.code === "ok") {
                        offset = result.data.offset;
                    } else {
                        btnLoadMore.style.display = "none";
                    }
                    listContainer.innerHTML += result.data.html;
                })
                .catch(error => console.log('error', error));

        })
    },


}


export default News;
